var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { staticClass: "question-answer-list" },
      [
        _vm._l(_vm.questionAnswers, function(ref) {
          var question = ref.question
          var answer = ref.answer
          return [
            _c("li", { staticClass: "question-answer" }, [
              _vm._v("   " + _vm._s(question) + ": " + _vm._s(answer))
            ])
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }